import { render, staticRenderFns } from "./navigationnew.vue?vue&type=template&id=995f9d2e&scoped=true"
import script from "./navigationnew.vue?vue&type=script&lang=js"
export * from "./navigationnew.vue?vue&type=script&lang=js"
import style0 from "./navigationnew.vue?vue&type=style&index=0&id=995f9d2e&prod&lang=less"
import style1 from "./navigationnew.vue?vue&type=style&index=1&id=995f9d2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995f9d2e",
  null
  
)

export default component.exports